<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">事前仮予約{{ title }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn v-permit.BOOKING_SAVE @click="save()">保存</v-btn>
        <v-btn @click="$router.push('/B2200')">戻る</v-btn>
        <table-upload :title="$t('app.buttons.csvUpload')" @input="upload" />
        <a @click="$downloadTemplate('B2201', 'excel')" href="#"
          >upload template</a
        >
        <a
          @click="$downloadTemplate('B2201ME', 'excel')"
          href="#"
          style="margin-left: 20px"
          >TV事業本部用template</a
        >
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-card-title primary-title style="padding-left: 8px">
        <span class="headline mb-0">ヘッダー部</span>
      </v-card-title>
      <v-form ref="form" v-model="valid" value>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                :rules="partnerRules"
                clearable
                key="partner"
                url="companies/kv?type=PARTNER"
                v-model="sa.partnerId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                :rules="buRules"
                clearable
                url="divisions/kv?type=BU"
                v-model="sa.headquarterId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="blNoRules"
                clearable
                key="blNo"
                label="B/L No"
                v-model="sa.blNo"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.forwarder')"
                :rules="forwarderRules"
                key="forwarderId"
                :url="forwarderUrl"
                v-model="sa.forwarderId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="shipNameRules"
                clearable
                key="shipName"
                label="本船名"
                v-model="sa.shipName"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="volNoRules"
                clearable
                key="volNo"
                label="Ｖｏｙ　ＮＯ"
                v-model="sa.volNo"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <date-input
                :label="$t('app.labels.etd')"
                :preRules="etdRules"
                key="etd"
                v-model="sa.etd"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <date-input
                :label="$t('app.labels.eta')"
                :preRules="etaRules"
                key="eta"
                v-model="sa.eta"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                :rules="loadingPortRules"
                key="loadingPortCode"
                url="ports/kv"
                v-model="sa.loadingPortCode"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                :rules="dischargePortRules"
                key="dischargePortCode"
                url="ports/kv"
                v-model="sa.dischargePortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-autocomplete
                :items="[
                  { text: 'ブッキング', value: 'booking' },
                  { text: 'バンニング', value: 'vanneing' },
                ]"
                :rules="typeRules"
                label="タイプ"
                v-model="sa.bookingType"
              ></v-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <v-checkbox
                    hide-details
                    v-if="isMe"
                    label="納入指示者へ送信"
                    primary
                    v-model="sa.needBookingSend"
                  ></v-checkbox>
                </v-flex>
                <v-flex md6 pr-2>
                  <v-checkbox
                    hide-details
                    v-if="isMe"
                    label="着荷計画書発信する"
                    primary
                    v-model="sa.needSytcSend"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-card-title primary-title style="padding-left: 8px">
        <span class="headline mb-0">明細部</span>
      </v-card-title>
      <v-data-table
        :headers="isMe ? meHeaders : headers"
        :items="sa.packages"
        :rows-per-page-items="[50]"
        class="elevation-1 mt-2 mb-2 inline-edit"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <v-text-field
                placeholder="コンテナＮＯ"
                v-model="props.item.containerNo"
              ></v-text-field>
            </td>
            <td>
              <remote-autocomplete
                placeholder="コンテナサイズ"
                url="container-types/kv"
                v-model="props.item.containerTypeId"
              />
            </td>
            <td>
              <v-text-field
                placeholder="製品名"
                v-model="props.item.skuCode"
              ></v-text-field>
            </td>
            <td v-if="isMe">
              <v-text-field
                placeholder="物流社内品番"
                v-model="props.item.logisticsSku"
              ></v-text-field>
            </td>
            <td>
              <remote-autocomplete
                :placeholder="$t('app.labels.productCode')"
                url="products/kv"
                v-model="props.item.productCode"
              />
            </td>
            <td>
              <v-text-field
                placeholder="数量"
                type="number"
                v-model="props.item.totalQty"
              ></v-text-field>
            </td>
            <td>
              <v-icon @click="add()">add</v-icon>
              <v-icon @click="remove(props.item)">remove</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div style="display: flex; padding: 10px">
        <div style="margin: 0 10px">コンテナ本数計：{{ containerCount }}</div>
        <div style="margin: 0 10px">数量計：{{ skuCount }}</div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {},
  methods: {
    load() {},

    getCodeAfterSplit(s) {
      return s && s.split(":")[0];
    },

    upload(data) {
      if (this.isMe) {
        this.uploadMe(data);
      } else {
        this.getCompanyId("PARTNER", this.getCodeAfterSplit(data[1][0]));
        this.getCompanyId("SUPPLIER", this.getCodeAfterSplit(data[1][2]));
        this.sa.blNo = data[1][1];
        this.sa.shipName = data[1][3];
        this.sa.volNo = data[1][4];
        this.sa.etd = this.dateFormat(String(data[1][5]));
        this.sa.eta = this.dateFormat(String(data[1][6]));
        this.sa.loadingPortCode = this.getCodeAfterSplit(data[1][7]);
        this.sa.dischargePortCode = this.getCodeAfterSplit(data[1][8]);
        this.sa.packages = [];
        for (var i = 4; i < data.length; i++) {
          console.log(data[i]);
          if (data[i].length > 0) {
            this.sa.packages.push({
              containerNo: data[i][0],
              containerTypeId: this.exchangeContainerSize(data[i][1]),
              skuCode: data[i][2],
              logisticsSku: data[i][4],
              totalQty: data[i][3],
              seq: new Date().getTime() + i * 1000,
              itemSeq: new Date().getTime() + i * 10000,
            });
          }
        }
        this.removeFirstEmptyPkg();
      }
    },
    uploadMe(data) {
      console.log(data);

      this.getCompanyId("PARTNER", this.getCodeAfterSplit(data[1][1]));
      this.getCompanyId("SUPPLIER", this.getCodeAfterSplit(data[4][1]));
      this.sa.blNo = data[8][1];
      this.sa.shipName = data[4][2];
      this.sa.volNo = data[4][3];
      this.sa.etd = this.dateFormat(String(data[4][5]));
      this.sa.eta = this.dateFormat(String(data[6][5]));
      this.sa.loadingPortCode = this.getCodeAfterSplit(data[4][4]);
      this.sa.dischargePortCode = this.getCodeAfterSplit(data[6][4]);
      this.sa.packages = [];
      var currentContainerNo;
      var currentContaienrSize;
      for (var i = 11; i < data.length; i++) {
        if (data[i].length > 0) {
          if (data[i][1]) {
            currentContainerNo = data[i][1];
          }
          if (data[i][3]) {
            currentContaienrSize = data[i][3];
          }
          this.sa.packages.push({
            containerNo: currentContainerNo,
            containerTypeId: this.exchangeContainerSize(currentContaienrSize),
            skuCode: data[i][4],
            logisticsSku: data[i][11],
            totalQty: data[i][5],
            seq: new Date().getTime() + i * 1000,
            itemSeq: new Date().getTime() + i * 10000,
          });
        }
        this.removeFirstEmptyPkg();
      }
    },
    removeFirstEmptyPkg() {
      var firstPkg = this.sa.packages[0];
      if (
        !firstPkg.containerNo &&
        !firstPkg.containerTypeId &&
        !firstPkg.skuCode &&
        !firstPkg.totalQty
      ) {
        this.sa.packages.splice(0, 1);
      }
    },

    dateFormat(v) {
      return v.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
    },

    exchangeContainerSize(size) {
      switch (size) {
        case "20F":
          return "CONTAINER_TYPE-20F";
        case "40F":
          return "CONTAINER_TYPE-40F";
        case "40H":
          return "CONTAINER_TYPE-40FHQ";
        case "40HQ":
          return "CONTAINER_TYPE-40FHQ";
        case "40FHQ":
          return "CONTAINER_TYPE-40FHQ";
      }
    },

    getCompanyId(companyType, companyCode) {
      this.$http
        .get(`/companies/code/${companyType}/${companyCode}`)
        .then((res) => {
          this.sa = {
            ...this.sa,
            partnerId:
              companyType === "PARTNER"
                ? res.data.companyId
                : this.sa.partnerId,
            forwarderId:
              companyType === "SUPPLIER"
                ? res.data.companyId
                : this.sa.forwarderId,
          };
        });
    },

    save() {
      if (this.$refs.form.validate() && this.checkPackageData()) {
        if (this.isBooking || this.isBookingBs) {
          this.sa.packages
            .filter((p) => !p.containerNo)
            .forEach((pkg) => {
              pkg.containerNo = "9999999999";
            });
        }

        this.$http
          .put("/shipping-advices/check-sys-bl-if-exist", this.sa)
          .then((r) => {
            if ("COMPLETE" === r.data) {
              this.$message(
                "Error",
                "当該仮予約データに対して正式データが存在しているので、二重登録しないてください。"
              );
              return;
            } else if ("PART" === r.data) {
              this.$confirm({
                content:
                  "当該仮予約データのBL.No/コンテナNoと類似する正式データが存在しているので、二重登録を防ぐために、ご確認の上で、ご登録お願い致します。",
              }).then(() => {
                this.doSave();
              });
            } else {
              this.doSave();
            }
          });
      }
    },
    doSave() {
      this.$http
        .post("/shipping-advices/create-booking-sa", this.sa)
        .then((res) => {
          if (this.canSendDirectly) {
            var content = "納入指示画面へ遷移しますか。";
            var path = "/B0600";
            if (res.data.allNeedReserve) {
              content = "倉庫別予約一覧へ遷移しますか。";
              path = "/B2300";
            }
            this.$confirm({
              content: content,
              rejectAction: "いいえ",
            })
              .then(() => {
                return this.$http
                  .put(`shipping-advices/booking-sa-send/${res.data.id}`)
                  .then(() => {
                    this.$message("", "Success");
                    this.$router.push({
                      path: path,
                      query: {
                        blNo: res.data.blNo,
                      },
                    });
                  })
                  .catch((err) => {
                    this.$showError(err);
                  });
              })
              .catch(() => {
                this.edit(res.data.id);
                this.$message("", "success");
              });
          } else {
            this.edit(res.data.id);
            this.$message("", "success");
          }
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    edit(id) {
      this.$message("", this.$t("B0400.messages.success.completed"));
      if (this.sa.id == null) {
        this.$router.push({
          name: "B2201Edit",
          query: {
            id: id,
          },
        });
      } else {
        this.load();
      }
    },
    add() {
      this.sa.packages.push({
        seq: new Date().getTime(),
        itemSeq: new Date().getTime(),
      });
      this.sa.packages = [...this.sa.packages];
    },
    remove(data) {
      const index = this.sa.packages.indexOf(data);
      this.sa.packages.splice(index, 1);
    },
    checkPackageData() {
      if (this.sa.packages.length === 0) {
        this.$message("", "コンテナ情報をご入力ください。");
        return false;
      }
      if (
        (this.isBooking || this.isVanneing) &&
        (this.sa.packages.filter((p) => !p.skuCode).length > 0 ||
          this.sa.packages.filter((p) => !p.totalQty).length > 0)
      ) {
        this.$message("", "製品名＆数量をご入力ください");
        return false;
      }
      if (
        this.isBookingBs &&
        this.sa.packages.filter((p) => !p.containerTypeId).length > 0
      ) {
        this.$message("", "コンテナサイズ必須");
        return false;
      }
      if (
        this.isVanneing &&
        (this.sa.packages.filter((p) => !p.containerTypeId).length > 0 ||
          this.sa.packages.filter((p) => !p.containerNo).length > 0)
      ) {
        this.$message("", "コンテナNO&コンテナサイズをご入力ください。");
        return false;
      }
      if (this.sameContainerNoDifType()) {
        this.$message(
          "",
          "同じコンテナNoの場合、コンテナサイズも統一する必要があります。（例：" +
            this.sameContainerNoDifType() +
            "）"
          //'不整合が発生しています、ご確認ください。'
        );
        return false;
      }
      return true;
    },
    loadBu() {
      if (!this.sa.headquarterId) {
        var employee = JSON.parse(localStorage.getItem("currentEmployee"));
        if (employee && employee.buId) {
          this.$set(this.sa, "headquarterId", employee.buId);
          // this.sa.headquarterId = employee.buId
        }
      }
    },
    sameContainerNoDifType() {
      var containerNos = this.sa.packages
        .map((p) => p.containerNo)
        .reduce((total, containerNo) => {
          if (total.indexOf(containerNo) == -1) {
            total.push(containerNo);
          }
          return total;
        }, []);
      for (var i = 0; i < containerNos.length; i++) {
        var containerTypes = this.sa.packages
          .filter((p) => p.containerNo === containerNos[i])
          .map((p) => p.containerTypeId)
          .reduce((total, containerTypeId) => {
            if (total.indexOf(containerTypeId) == -1) {
              total.push(containerTypeId);
            }
            return total;
          }, []);
        if (containerTypes.length > 1) {
          return containerNos[i];
        }
      }
      return false;
    },
  },
  data() {
    return {
      sa: {
        needSytcSend: true,
        bookingType: "vanneing",
        packages: [
          {
            seq: new Date().getTime(),
            itemSeq: new Date().getTime(),
          },
        ],
      },
      title: "新規",
      valid: false,
      loading: false,
      selected: [],
      dialog: {
        show: false,
      },
      historyData: [],
      pagination: {
        page: 1,
      },
      errors: {
        HAS_SENT: "事前仮予約送信済",
        SKU_NOT_FOUND: "品番が存在していません。",
        TEMP_WITHOUT_PRODUCT: "品種名は必須としてください。",
      },
      headers: [
        {
          text: "コンテナＮＯ",
          value: "",
          sortable: false,
        },
        {
          text: "コンテナサイズ",
          value: "",
          sortable: false,
        },
        {
          text: "製品名",
          value: "",
          sortable: false,
        },
        {
          text: "品種",
          value: "",
          sortable: false,
        },
        {
          text: "数量",
          value: "",
          sortable: false,
        },
        {
          text: "ACTION",
          value: "",
          sortable: false,
        },
      ],
      meHeaders: [
        {
          text: "コンテナＮＯ",
          value: "",
          sortable: false,
        },
        {
          text: "コンテナサイズ",
          value: "",
          sortable: false,
        },
        {
          text: "製品名",
          value: "",
          sortable: false,
        },
        {
          text: "物流社内品番",
          value: "",
          sortable: false,
        },
        {
          text: "品種",
          value: "",
          sortable: false,
        },
        {
          text: "数量",
          value: "",
          sortable: false,
        },
        {
          text: "ACTION",
          value: "",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.$loadParams();
    this.loadBu();
  },
  computed: {
    forwarderUrl() {
      return this.sa.status === "事前納入指示Mail送信済"
        ? "companies/kv-include-all"
        : "companies/forwarders/kv";
      // return "companies/kv-include-all";
    },
    partnerRules(v) {
      return [(v) => !!v || "海外取引先必須"];
    },
    buRules(v) {
      return [(v) => !!v || "事業本部必須"];
    },
    blNoRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "B/L No必須"];
    },
    forwarderRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "船社名必須"];
    },
    shipNameRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "本船名必須"];
    },
    volNoRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "Ｖｏｙ　ＮＯ必須"];
    },
    etdRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "ETD必須"];
    },
    etaRules(v) {
      return [(v) => !!v || "ETA必須"];
    },
    loadingPortRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "積出港必須"];
    },
    dischargePortRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "陸揚港必須"];
    },
    skuCodeRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "製品名必須"];
    },
    totalQtyRules(v) {
      if (this.isBookingBs) {
        return [];
      }
      return [(v) => !!v || "数量必須"];
    },
    containerNoRules(v) {
      if (this.isVanneing) {
        return [(v) => !!v || "コンテナＮＯ必須"];
      }
      return [];
    },
    containerSizeRules() {
      if (this.isBooking) {
        return null;
      }
      return [(v) => !!v || "コンテナサイズ必須"];
    },
    typeRules() {
      return [(v) => !!v || "タイプ必須"];
    },
    isBooking() {
      return (
        this.sa.bookingType === "booking" &&
        this.sa.headquarterId !== "5e672626-50be-4948-9917-68a4120d86b9"
      );
    },
    isVanneing() {
      return this.sa.bookingType === "vanneing";
    },
    isBookingBs() {
      return (
        this.sa.bookingType === "booking" &&
        this.sa.headquarterId === "5e672626-50be-4948-9917-68a4120d86b9"
      );
    },
    isMe() {
      return this.sa.headquarterId === "47ceb6d6-520a-40b7-9a94-f9de756eb70b";
    },
    canSendDirectly() {
      return this.isMe && !this.sa.needBookingSend;
    },
    minEta() {
      if (!this.sa.etd) return null;
      return new Date(this.sa.etd).format("yyyyMMdd");
    },
    maxEtd() {
      if (!this.sa.blIssueDate) {
        if (!this.sa.eta) {
          return null;
        } else {
          return new Date(this.sa.eta).format("yyyyMMdd");
        }
      }
      var date = new Date(this.sa.blIssueDate);
      date.setDate(date.getDate() + 10);
      return date.format("yyyyMMdd");
    },
    minEtd() {
      if (!this.sa.blIssueDate) return null;
      var date = new Date(this.sa.blIssueDate);
      date.setDate(date.getDate() - 10);
      return date.format("yyyyMMdd");
    },
    containerCount() {
      var containerNos = [];
      this.sa.packages
        .filter((pkg) => pkg.containerNo)
        .forEach((pkg) => {
          if (containerNos.indexOf(pkg.containerNo) === -1) {
            containerNos.push(pkg.containerNo);
          }
        });
      return containerNos.length;
    },
    skuCount() {
      return this.sa.packages
        .map((pkg) => pkg.totalQty || 0)
        .reduce((t, c) => {
          return (t += Number(c));
        }, 0);
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
};
</script>
